/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFacebookIcon16Solid = forwardRef('LogoFacebookIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m10.625 8.763.5-2.763H8.8V5c0-.671-.048-1.5.968-1.5h1.2V1.166S9.865 1 8.969 1C7.1 1 6.249 2.05 6.249 4.177V6H4.125v2.763h2.123V15H8.8V8.763h1.825Z" })));
});
